<template>
    <div class="h-full urban-box">
        <el-container>
            <el-header>
                <div class="urban-top">
                    <div class="select-city">
                        <!--                    <el-select v-model="city" placeholder="Select">-->
                        <!--                        <template #prefix>-->
                        <!--                        <span style="padding-left: 5px;">-->
                        <!--                            <i class="iconfont icon-dingwei"></i>-->
                        <!--                        </span>-->
                        <!--                    </template>-->
                        <!--                    <el-option-->
                        <!--                        :key="item.cityCode"-->
                        <!--                        :label="item.name"-->
                        <!--                        :value="item.cityCode"-->
                        <!--                        v-for="item in cityList">-->
                        <!--                    </el-option>-->
                        <!--                </el-select> &ndash;&gt;-->
                        <CitySelect
                            v-model="city"
                            :showName="cityName"
                            @update:modelValue="updateMessage"
                        >
                        </CitySelect>
                        <!-- <CitySelect v-model="city" :show-name="cityName" @update:modelValue="updateMessage"></CitySelect> -->
                        <span>-&nbsp;&nbsp;{{ area.name }}</span>
                    </div>
                    <div class="urban-top-title">
                        <h3 class="home-title">子市场数据概览</h3>
                    </div>

                    <span class="home-description">数据时间：{{ time }}</span>
                </div>
<!--                <el-tabs v-model="tabValue" class="urban-tabs" @tab-change="handleClick">-->
<!--                    <el-tab-pane-->
<!--                        v-for="v in areaList"-->
<!--                        :label="v.name"-->
<!--                        :key="v.areaCode"-->
<!--                    />-->
<!--                </el-tabs>-->
              <div class="urban-tabs">
                <tab-button-group
                    :data="tabData"
                    :index="tabValue"
                    @on-change-tab="handleClick"
                />
              </div>
            </el-header>
            <el-main ref="urbanRef">
                <div class="home-content">
                    <div>
                      <High :code="areaCode"/>
                    </div>
                    <div class="home-second-content">
                        <div class="report-title">
                            <MessageHeader msg="市场报告"></MessageHeader>
                            <span class="more-btn" @click="toReport">
                                查看更多
                                <i class="iconfont icon-jiantou-xiangyou"></i>
                            </span>
                        </div>
                        <div class="record-list">
                            <el-row :gutter="20">
                                <el-col :xl="8" :lg="12" :md="12" :sm="12" :xs="12" v-for="item in reportList" :key="item.id">
                                    <ReportItem :item="item"></ReportItem>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script setup>
import MessageHeader from '@/components/MessageHeader'
import ReportItem from '@/components/reportItem'
import High from './components/high'

import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";
import request from "@/service/request";
import {GetCityAreaList, getReport} from "@/service/api";
import CitySelect from '@/components/citySelect'
import {useRoute, useRouter} from "vue-router";
import TabButtonGroup from "@/components/tabButtonGroup.vue";
import {emptyArray} from "@/tool/number";
import {ElMessage} from "element-plus";


const route = useRoute();
let {areaCode: ac, cityCode: cc } = route.query;
let time = localStorage.getItem('time')
const cityList = JSON.parse(localStorage.getItem('cityList'))
let _cityCode = cc || cityList[0].cityCode;
let _city = cityList.find(e => e.cityCode === _cityCode);

const city = ref(_cityCode)
const cityName = ref(_city.name)
const areaCode = ref('')
const areaList = ref([])
const urbanRef = ref(null)
const tabValue = ref(0)

const area = computed(() => {
  if(areaCode.value){
    return areaList.value.find(e => e.code === areaCode.value)
  }else{
    return {};
  }
})

const tabData = computed(() => {
  return areaList.value.map(e => e.name);
})

// 切换tab
const handleClick = (tab) => {
    let ele = urbanRef.value.$el
    ele.scrollTop = 0
    tabValue.value = tab
    areaCode.value = areaList.value[parseInt(tab)].code
}
const reportList = ref([])
const getReportList = async () => {
    let data = await request({
        url: getReport,
        data: {
            pageNum: 1,
            pageSize: 5,
            cityCodes: city.value
        }
    })
    reportList.value = data.rows || []
}

const getAreaList = async () => {
  let {data} = await request({
    method: 'get',
    url: GetCityAreaList,
    data: {
      cityCode: city.value
    }
  })

  if(emptyArray(data)){
    ElMessage({
      message: '没有可显示区县',
      type: 'error',
      duration: 2000,
      onClose: () => {

      }
    });
  }else{
    areaList.value = data;
    if(ac){
      tabValue.value = data.findIndex(e => e.code === ac);
      areaCode.value = ac;
      ac = null;
    }else{
      tabValue.value =  0;
      areaCode.value = data[0].code;
    }
  }
}

watch(city, () => {
  getAreaList();
}, {immediate: true})

function handleResize(){
    window.reload();
}

onMounted(() => {
    getReportList();
    window.addEventListener('resize', handleResize);
});

const updateMessage = (e) => {
    console.log('11212121212121211211');
    console.log(e);
    getReportList()
    console.log('11212121212121211211');
    
}

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
});

// 跳转到报告
const router = useRouter()
const toReport = () => {
  router.replace('/insight/marketReport')
}

</script>

<style lang="less" >

.urban-box {
    background: url('../../../assets/images/u_agg_bg.png') no-repeat;
    background-size: 100%;
    .el-container {
        height: 100%;
        overflow: hidden;

        .el-header {
            height: 120px;
        }

        .el-main {
            padding-top: 0;
        }
    }
}

.urban-tabs {
    width: 100%;

    .el-tabs__header {
        margin: 0;

        .el-tabs__nav-wrap::after {
            width: 0;
        }

        .el-tabs__item {
            font-size: 14px;
            color: #777;
            text-decoration: none;
            border-radius: 15px;
            padding: 0 18px !important;
            height: 30px;
            line-height: 30px;
        }

        .el-tabs__item.is-active {
            color: #fff !important;
            background: linear-gradient(90deg, #2B90E4 0%, #4BADFF 99%);
        }

        .el-tabs__active-bar {
            display: none;

        }
    }

}

.urban-top {
    padding-top: 20px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    .select-city {
        flex-shrink: 0;
        width: 300px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .icon-dingwei {
            font-size: 18px;
            color: #1378D7;
        }
    }

    .urban-top-title {
        flex: 1;
        text-align: center;

        .home-title {
            font-size: 22px;
            font-weight: bold;
            color: @text-color-title;
        }
    }

    .home-description {
        padding-top: 12px;
        font-size: 14px;
        color: @text-color-primary;
    }
}

.home-content {
    padding-bottom: 40px;

    .home-second-content {
        margin-top: 40px;

        .home-second-list {
            margin-top: 20px;
            width: 100%;
            height: 328px;
            background: #FFFFFF;
            box-sizing: border-box;
            padding: 30px;
        }

        .lease-chart {
            margin-top: 20px;
            width: 100%;
            height: 373px;
            background: #FFFFFF;
            box-sizing: border-box;
            padding-top: 25px;
        }

        .report-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .more-btn {
                display: flex;
                align-items: center;
                font-size: 14px;
                cursor: pointer;
                color: #1477C9;

                .icon-jiantou-xiangyou {
                    font-size: 12px;
                }
            }
        }

        .record-list {
            .el-col {
                margin-top: 20px;
            }
            
            width: 100%;
        }
    }
}
</style>